export default __webpack_public_path__ + "static/cashflow_new_2-746ededc3de89d9423cda462a199d334.jpg";